import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./HomeRevealFloating.css";
import { Col, Container, Row } from "reactstrap";
import { getBestSellerProducts } from "../../appState/slices/product/productSlice";
import { useNavigate } from "react-router-dom";

const HomeRevealFloating = () => {

    const products = useSelector(
        (state) => state.product.bestsellerproducts
    );
    const user = useSelector((state) => state.auth.user);

    const [open, setOpen] = useState(false);

    const [activeIndex, setActiveIndex] = useState(0);


    const openReveal = (index = 0) => {
        setActiveIndex(index);
        setOpen(true);
    };

    const nextProduct = () => {
        setActiveIndex((prev) =>
            prev === products.length - 1
                ? 0
                : prev + 1
        );
    };

    const prevProduct = () => {
        setActiveIndex((prev) =>
            prev === 0
                ? products.length - 1
                : prev - 1
        );
    };

    const navigate = useNavigate();
    const viewDetails = (name, id) => {
        navigate(`/${encodeURIComponent(name.replaceAll(" ", "-"))}/${id}`);
    };

    return (
        <>

            {/* FLOATING PREVIEW */}

            <div
                className="floating-reveal"
                onClick={() => openReveal(0)}
            >

                <div className="floating-stack">

                    {products?.slice(0, 3).map((product, index) => (

                        <div
                            className={`floating-card floating-card-${index}`}
                            key={index}
                        >

                            <img
                                src={product?.defaultImageUrl}
                                alt=""
                            />

                        </div>

                    ))}

                </div>

            </div>

            {/* FULLSCREEN PRODUCT VIEW */}

            {open && (

                <div className="reveal-fullscreen">

                    {/* CLOSE */}

                    <button
                        className="fullscreen-close"
                        onClick={() => setOpen(false)}
                    >
                        ✕
                    </button>

                    {/* LEFT NAV */}

                    <button
                        className="nav-btn nav-left"
                        onClick={prevProduct}
                    >
                        ←
                    </button>

                    {/* PRODUCT */}

                    <div className="fullscreen-product">
                        <div className="fullscreen-product-heading t1">Best Sellers</div>

                        <img
                            src={
                                products[activeIndex]
                                    ?.defaultImageUrl
                            }
                            alt=""
                            className="fullscreen-product-image"
                        />

                        <div className="fullscreen-product-details">

                            <div className="fullscreen-product-name">
                                {
                                    products[activeIndex]
                                        ?.name
                                }
                            </div>

                            <div className="fullscreen-product-price">
                                ₹ {
                                    products[activeIndex]
                                        ?.defaultPrice
                                }
                            </div>

                            <div className="fullscreen-product-buttons">

                                <Container fluid>


                                    {
                                        user ?
                                            <Row className="g-3">
                                                <Col
                                                    xs="12"
                                                >

                                                    <button onClick={() => viewDetails(products[activeIndex].name, products[activeIndex]._id)} className="fullscreen-view-btn">
                                                        View
                                                    </button>

                                                </Col>

                                                {/* <Col
                                                    xs="6"
                                                >

                                                    <button className="fullscreen-cart-btn">
                                                        Add To Cart
                                                    </button>

                                                </Col> */}
                                            </Row>

                                            :
                                            <Row className="g-3">
                                                <Col
                                                    xs="12"
                                                >

                                                    <button onClick={() => viewDetails(products[activeIndex].name, products[activeIndex]._id)} className="fullscreen-view-btn">
                                                        View
                                                    </button>

                                                </Col>

                                            </Row>
                                    }



                                </Container>

                            </div>


                        </div>

                    </div>

                    {/* RIGHT NAV */}

                    <button
                        className="nav-btn nav-right"
                        onClick={nextProduct}
                    >
                        →
                    </button>

                </div>

            )}

        </>
    );
};

export default HomeRevealFloating;